import { connectRefinementList } from "instantsearch.js/es/connectors";

function escapeHtml(value: string): string {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

/**
 * Action-bar toggle « Prix en baisse » — filters has_promotion:=true, keeps user sort.
 */
export function createPromotionToggleWidget(container = "#toggle-has-promotion") {
    const mount = document.querySelector(container);
    if (!mount) {
        return null;
    }

    const widget = connectRefinementList<{ container: string }>(
        (renderOptions, isFirstRender) => {
            const { items, refine, widgetParams } = renderOptions;
            const el = document.querySelector(widgetParams.container);
            if (!el) {
                return;
            }

            const trueItem = items.find(
                (item) => String(item.value) === "true",
            );
            const isOn = Boolean(trueItem?.isRefined);

            if (isFirstRender) {
                el.addEventListener("click", (event) => {
                    const target = event.target as HTMLElement;
                    if (target.closest("button.toggle-promo")) {
                        refine("true");
                    }
                });
            }

            el.innerHTML =
                `<button type="button" class="marketplace-action-bar__btn toggle-promo${isOn ? " on marketplace-action-bar__btn--primary" : ""}"` +
                ` aria-pressed="${isOn ? "true" : "false"}"` +
                ` data-testid="toggle-has-promotion" data-attr="listing-promo-toggle">` +
                `<span class="toggle-promo__icon" aria-hidden="true">↓</span>` +
                `<span class="toggle-promo__label">${escapeHtml("Prix en baisse")}</span>` +
                `<span class="sw" aria-hidden="true"></span>` +
                `</button>`;
        },
    );

    return widget({
        container,
        attribute: "has_promotion",
        limit: 2,
        transformItems(items) {
            return items.filter((item) => String(item.value) === "true");
        },
    });
}
